import { reactQueryDelete } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useState } from "react";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

export const useLeaveSpace = ({
  refetchSpaceMembers,
  spaceId,
  setIsConfirmationModalOpen,
}: {
  refetchSpaceMembers: () => void;
  spaceId: number;
  setIsConfirmationModalOpen: (isOpen: boolean) => void;
}) => {
  const [memberToDelete, setMemberToDelete] = useState<any>(null);
  const toastr = useToast();
  const { mutate: leaveSpaceMutation, isPending: isLeaving } = useMutation({
    mutationFn: async () => {
      await reactQueryDelete(
        internalApi.spaceMembers.leaveSpace({
          spaceId,
          memberId: memberToDelete?.community_member_id,
        }),
      );
    },
    onError: (error: Error) => {
      toastr.error(error.message);
    },

    onSuccess: () => {
      toastr.success(
        t(
          "members_directory.community_members.actions.space.successfully_removed",
        ),
      );
      refetchSpaceMembers();
    },
    onSettled: () => {
      setIsConfirmationModalOpen(false);
    },
  });

  return {
    leaveSpaceMutation,
    isLeaving,
    memberToDelete,
    setMemberToDelete,
  };
};
